// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfv_a"};